export { MODAL_PORTAL_TARGET_SELECTOR } from 'shared/components/molecules/Modal/config';
import Modal from 'shared/components/molecules/Modal/Modal';

export default Modal;
